<div class="assessment-manager-edit">
  <div class="header">
    <div>
      <h2>{{assessmentId ? 'Edit Assessment' : 'Create Assessment'}}</h2>
      <div class="subtitle" *ngIf="project">Project: {{project.name}}</div>
    </div>
    <div class="actions">
      <button pButton type="button" label="Save" icon="pi pi-check" (click)="saveAssessment()" [disabled]="saving"></button>
      <button pButton type="button" class="p-button-text" label="Cancel" (click)="cancel()"></button>
    </div>
  </div>

  <div class="form-grid">
    <mat-form-field appearance="outline">
      <mat-label>Assessment Name <span class="required-marker">*</span></mat-label>
      <input matInput name="assessmentName" [(ngModel)]="assessmentName" required />
      <mat-error *ngIf="showValidationErrors && !isAssessmentNameValid">Assessment name is required.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Assessment Lead <span class="required-marker">*</span></mat-label>
      <mat-select name="leadUserId" [(ngModel)]="leadUserId" required>
        <mat-option *ngFor="let user of users" [value]="user.userId">
          {{user.fullName || user.emailAddress}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="showValidationErrors && !isLeadValid">Assessment lead is required.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput name="startDate" [matDatepicker]="startPicker" [(ngModel)]="startDate" />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput name="endDate" [matDatepicker]="endPicker" [(ngModel)]="endDate" />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select name="status" [(ngModel)]="status">
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">
          {{option.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="panel">
    <h3>Available Controls</h3>
    <p-table [value]="controlItems" dataKey="projectControlItemId"
              [(selection)]="selectedControlItems"
              selectionMode="multiple"
              (onRowSelect)="syncSelectedControls()"
              (onRowUnselect)="syncSelectedControls()"
              (onHeaderCheckboxToggle)="syncSelectedControls()">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 2rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th>Control ID</th>
          <th>Short Name</th>
          <th>Category</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td><p-tableCheckbox [value]="item"></p-tableCheckbox></td>
          <td>{{item.controlItem?.complianceAreaControlId}}</td>
          <td>{{item.controlItem?.shortName}}</td>
          <td>{{item.controlItem?.category}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
